
import { mapState } from 'vuex'
import ScrouselTabs from '~/components/producet-scence/scrousel-tabs.vue'
import CreateExamination from '~/components/producet-scence/create-examination.vue'
import PartAll from '~/components/producet-scence/part-all.vue'
import { getHomePageConfig } from '~/api/home/index.js'

export default {
  name: 'Satisfaction',
  components: {
    ScrouselTabs,
    CreateExamination,
    PartAll,
  },
  layout: 'scence-single',
  data() {
    return {
      ConfData: {},
      nexturl: '/create/scene/create-template/?scene=satisfaction',
    }
  },
  fetchOnServer: false,
  async fetch() {
    await this.init()
  },
  head: {
    title: '问卷网-满意度调查调研-客户满意度调查问卷',
    link: [{ rel: 'canonical', href: 'https://www.wenjuan.com/satisfaction/' }],
    meta: [
      {
        hid: 'keywords',
        name: 'keywords',
        content: '满意度,满意度调查,满意度调查问卷,满意度问卷调查,问卷网',
      },
      {
        hid: 'description',
        name: 'description',
        content:
          '问卷网，专业支持各类满意度调查：员工满意度调查、客户满意度调查、顾客满意度调查、学校满意度调查，可通过邮件、短信邀请答题，不限制答题人数。',
      },
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no',
      },
    ],
  },
  computed: {
    ...mapState(['isMobile', 'loginStatus']),
    href() {
      const path = '/create/scene/create-template/?scene=satisfaction'
      return this.loginStatus.loggedIn == 1 ? path : ''
    },
  },
  mounted() {
    this.setRegisterConfig()
  },
  methods: {
    init() {
      return getHomePageConfig().then(({ data }) => {
        this.ConfData = {
          userNum: data?.total_member_count / 10000,
          dataNum: data?.total_rspd_count / 100000000,
        }
      })
    },
    /**
     * 修改登入界面的配置
     */
    setRegisterConfig() {
      // 配置登入页面
      this.$store.commit('setLoginStatus', {
        config: { nexturl: this.nexturl },
        registerIndexParams: {
          next: encodeURIComponent(this.nexturl),
        },
      })
    },
    handLogin() {
      if (!this.loggedIn) {
        if (!this.isMobile)
          return this.$store.commit('setLoginStatus', {
            show: true,
            nextUrl: '/create/scene/create-template/?scene=satisfaction',
          })
        this.$href('/m/login/?quicklogin=1&emailorusername=&vvv=16728549930973728')
      }
    },
  },
}
